import { z } from "zod"

export const GROUPINGS = [
  "work_order",
  "status",
  "severity",
  "customer",
  "reporter",
] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const groupChoiceSchema = z.enum([...GROUPINGS, "none"])

export const GROUPING_LABELS: Record<Grouping, string> = {
  work_order: "Work order",
  status: "Status",
  severity: "Severity",
  customer: "Customer",
  reporter: "Reported by",
}
